export class AttributionConstants {
  public static EuroGlobalMap = [
    {
      country: 'Austria',
      attribution_statement: '© Bundesamt für Eich- und Vermessungswesen (BEV)',
    },
    {
      country: 'Belgium (including Luxembourg)',
      attribution_statement: '© Institut Géographique National (IGN-B)',
    },
    {
      country: 'Bosnia and Herzegovina',
      attribution_statement: '© Federalna uprava za geodetske i imovinsko-pravne poslovo',
    },
    {
      country: 'Bulgaria',
      attribution_statement: '© Агенция по геодезия, картография и кадастър (CADASTRE)',
    },
    {
      country: 'Croatia',
      attribution_statement: '© Državna geodetska uprava (DGU)',
    },
    {
      country: 'Cyprus',
      attribution_statement: '© Tmima Ktimatologiou Kai Chorometrias (DLS)',
    },
    {
      country: 'Czech Republic',
      attribution_statement: '© Zeměměřický úřad (ZU)',
    },
    {
      country: 'Denmark (including Faroe Islands & Greenland)',
      attribution_statement:
        '© Energi-, forsynings- og klimaministeriet / Styrelsen for Dataforsyning og Effektivisering (SDFE)',
    },
    {
      country: 'Estonia',
      attribution_statement: '© Eesti Maa-amet (MAAAMET)',
    },
    {
      country: 'Finland',
      attribution_statement: '© Maanmittauslaitos (NLS-F)',
    },
    {
      country: 'France',
      attribution_statement:
        '© Institut national de l’information géographique et forestière (IGN-F)',
    },
    {
      country: 'Georgia',
      attribution_statement: '© SAJARO REESTRIS EROVNULI SAAGENTO (NAPR)',
    },
    {
      country: 'Germany',
      attribution_statement: '© Bundesamt für Kartographie und Geodäsie (BKG)',
    },
    {
      country: 'Great Britain',
      attribution_statement:
        '© Ordnance Survey data: &copy; Crown copyright and database right [year] OS\n' +
        '                  OpenData is free to use under the\n' +
        '                  <a\n' +
        '                    href="http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"\n' +
        '                    target="_blank"\n' +
        '                    >Open Government Licence (OGL)</a/',
    },
    {
      country: 'Greece',
      attribution_statement: '© ΓΕΩΓΡΑΦΙΚΗ ΥΠΗΡΕΣΙΑ ΣΤΡΑΤΟΥ (HMGS)',
    },
    {
      country: 'Hungary',
      attribution_statement: '© Geoinformation Service of Hungarian Defence Forces (MHTEHI)',
    },
    {
      country: 'Iceland',
      attribution_statement: '© Landmælingar Íslands (LMI)',
    },
    {
      country: 'Ireland',
      attribution_statement: '© Ordnance Survey Ireland (OSI)',
    },
    {
      country: 'Kosovo',
      attribution_statement: '© Agjencia Kadastrale e Kosovës (KCA)',
    },
    {
      country: 'Italy',
      attribution_statement: '© Istituto Geografico Militare (IGM)',
    },
    {
      country: 'Latvia',
      attribution_statement: '© Latvijas Ģeotelpiskās informācijas aģentūra (LGIA)',
    },
    {
      country: 'Lithuania',
      attribution_statement: '© Nacionalinė žemės tarnyba prie Žemės ūkio ministerijos (NLS-L)',
    },
    {
      country: 'Malta',
      attribution_statement: '© Malta Planning Authority (MEPA)',
    },
    {
      country: 'Moldova',
      attribution_statement: '© Agenţia Relaţii Funciare şiCadastru a Republicii Moldova (ARFC)',
    },
    {
      country: 'Netherlands',
      attribution_statement: '© Kadaster (KADASTER)',
    },
    {
      country: 'Northern Ireland',
      attribution_statement: '© Land and Property Services (LPS)',
    },
    {
      country: 'Norway',
      attribution_statement: '© Kartverket (KARTVERKET)',
    },
    {
      country: 'Poland',
      attribution_statement: '© Główny Urząd Geodezji i Kartografii (GUGIK)',
    },
    {
      country: 'Portugal',
      attribution_statement: '© Direção Geral do Território (DGT)',
    },
    {
      country: 'Republic of North Macedonia',
      attribution_statement: '© Агенција за катастар на недвижности (KATASTAR)',
    },
    {
      country: 'Romania',
      attribution_statement: '© Agenţia Naţională De Cadastru Şi Publicitate Imobiliară (ANCPI)',
    },
    {
      country: 'Slovakia',
      attribution_statement: '© Úrad geodézie, kartografie a katastra Slovenskej republiky (UGKK)',
    },
    {
      country: 'Serbia',
      attribution_statement: '© Republički geodetski zavod (RGZ)',
    },
    {
      country: 'Slovenia',
      attribution_statement: '© Geodetska uprava Republike Slovenije (GU)',
    },
    {
      country: 'Spain',
      attribution_statement: '© Centro Nacional de Información Geográfica (CNIG)',
    },
    {
      country: 'Sweden',
      attribution_statement: '© Lantmäteriet (LANTMÄTERIET)',
    },
    {
      country: 'Switzerland including Liechtenstein',
      attribution_statement: '© Bundesamt für Landestopografie (swisstopo) (SWISSTOPO)',
    },
    {
      country: 'Ukraine',
      attribution_statement:
        '© Державна служба України з питань геодезії, картографії та кадастру (StateGeoCadastre)',
    },
  ];

  public static EuroRegionalMap = [
    {
      country: 'Austria',
      attribution: '© Bundesamt für Eich- und Vermessungswesen (BEV)',
      attribution_english: 'Federal Office of Metrology and Surveying',
    },
    {
      country: 'Belgium including Luxembourg',
      attribution: '© Institut Géographique National (IGNB)',
      attribution_english: 'National Geographic Institute',
    },
    {
      country: 'Croatia',
      attribution: '© Državna geodetska uprava (DGU)',
      attribution_english: 'State Geodetic Administration of the Republic of Croatia',
    },
    {
      country: 'Cyprus',
      attribution: '© Tmima Ktimatologiou Kai Chorometrias (DLS)',
      attribution_english: 'Department of Lands and Surveys',
    },
    {
      country: 'Czechia',
      attribution: '© Zeměměřický úřad (ZU)',
      attribution_english: 'Land Survey Office',
    },
    {
      country: 'Denmark including Faroe Islands',
      attribution:
        '© Energi-, forsynings- og klimaministeriet / Styrelsen for Dataforsyning og Effektivisering (SDFE)',
      attribution_english:
        'Danish Ministry of Energy, Utilities and Climate / Agency for Data supply and Efficiency',
    },
    {
      country: 'Estonia',
      attribution: '© Eesti Maa-amet (MAAAMET)',
      attribution_english: 'Estonian Land Board',
    },
    {
      country: 'Finland',
      attribution: '© Maanmittauslaitos (NLS-F)',
      attribution_english: 'National Land Survey of Finland',
    },
    {
      country:
        'France including\n' +
        'French Guiana,\n' +
        'Guadeloupe,\n' +
        'Martinique,\n' +
        'Mayotte,\n' +
        'Monaco,\n' +
        'Réunion,\n' +
        'Saint Barthélemy and\n' +
        'Saint Martin',
      attribution: '© Institut national de l’information géographique et forestière (IGN-F)',
      attribution_english: 'National Institute of Geographic and Forest Information',
    },
    {
      country: 'Georgia',
      attribution: '© SAJARO REESTRIS EROVNULI SAAGENTO (NAPR)',
      attribution_english: 'National Agency of Public Registry',
    },
    {
      country: 'Germany',
      attribution: '© Bundesamt für Kartographie und Geodäsie (BKG)',
      attribution_english: 'Federal Agency for Cartography and Geodesy',
    },
    {
      country: 'Greece',
      attribution: '© ΓΕΩΓΡΑΦΙΚΗ ΥΠΗΡΕΣΙΑ ΣΤΡΑΤΟΥ (HMGS)',
      attribution_english: 'Hellenic Military Geographical Service',
    },
    {
      country: 'Guernsey',
      attribution: '© States of Guernsey',
      attribution_english: '',
    },
    {
      country: 'Iceland',
      attribution: '© Landmælingar Íslands (LMI)',
      attribution_english: 'National Land Survey of Iceland',
    },
    {
      country: 'Ireland',
      attribution: '© Ordnance Survey Ireland (OSI)',
      attribution_english: 'Ordnance Survey Ireland',
    },
    {
      country: 'Italy including San Marino and Vatican City',
      attribution: '© Istituto Geografico Militare (IGM)',
      attribution_english: 'Italian Military Geographic Institute',
    },
    {
      country: 'Jersey',
      attribution: '© States of Jersey',
      attribution_english: '',
    },
    {
      country: 'Kosovo',
      attribution: '© Agjencia Kadastrale e Kosovës (KCA)',
      attribution_english: 'Kosovo Cadastral Agency',
    },
    {
      country: 'Latvia',
      attribution: '© Latvijas Ģeotelpiskās informācijas aģentūra (LGIA)',
      attribution_english: 'Latvian Geospatial Information Agency',
    },
    {
      country: 'Lithuania',
      attribution: '© Nacionalinė žemės tarnyba prie Žemės ūkio ministerijos (NLS-L)',
      attribution_english: 'National Land Survey',
    },
    {
      country: 'Malta',
      attribution: '© Malta Planning Authority (MEPA)',
      attribution_english: 'Malta Planning Authority',
    },
    {
      country: 'Moldova',
      attribution: '© Agenţia Relaţii Funciare şi Cadastru a Republicii Moldova (ARFC)',
      attribution_english: 'Agency for Land Relations and Cadastre of the Republic of Moldova',
    },
    {
      country: 'Netherlands',
      attribution: '© Kadaster (KADASTER) Cadastre',
      attribution_english: 'Cadastre, Land Registry and Mapping Agency',
    },
    {
      country: 'North Macedonia',
      attribution: '© Агенција за катастар на недвижности (KATASTAR)',
      attribution_english: 'Agency for Real Estate Cadastre',
    },
    {
      country: 'Norway',
      attribution: '© Kartverket (KARTVERKET)',
      attribution_english: 'Norwegian Mapping Authority',
    },
    {
      country: 'Poland',
      attribution: '© Główny Urząd Geodezji i Kartografii (GUGIK)',
      attribution_english: 'Head Office of Geodesy and Cartography',
    },
    {
      country: 'Portugal',
      attribution: '© Direção Geral do Território (DGT)',
      attribution_english: 'Directorate General for Territory',
    },
    {
      country: 'Slovakia',
      attribution: '© Úrad geodézie, kartografie a katastra Slovenskej republiky (UGKK)',
      attribution_english: 'Geodetic and Cartographic Institute Bratislava',
    },
    {
      country: 'Slovenia',
      attribution: '© Geodetska uprava Republike Slovenije (GU)',
      attribution_english: 'Surveying and Mapping Authority of the Republic of Slovenia',
    },
    {
      country: 'Spain including Andorra and Gibraltar',
      attribution: '© Centro Nacional de Información Geográfica (CNIG)',
      attribution_english: 'National Center of Geographic Information',
    },
    {
      country: 'Svalbard and Jan Mayen',
      attribution: '© Norsk Polarinstitutt (NPI)',
      attribution_english: 'Norwegian Polar Institute',
    },
    {
      country: 'Sweden',
      attribution: '© Lantmäteriet (LANTMÄTERIET)',
      attribution_english: 'The Swedish mapping, cadastral and land registration authority',
    },
    {
      country: 'Switzerland including Liechtenstein',
      attribution: '© Bundesamt für Landestopografie (swisstopo) (SWISSTOPO)',
      attribution_english: 'Federal Office of Topography',
    },
    {
      country: 'Ukraine',
      attribution:
        '© Державна служба України з питань геодезії, картографії та кадастру (StateGeoCadastre)',
      attribution_english: 'State Service of Ukraine for Geodesy, Cartography and Cadastre',
    },
    {
      country: 'United Kingdom (Great Britain, Isle of Man)',
      attribution:
        '© Ordnance Survey data: &copy; Crown copyright and database right [year] OS\n' +
        '                  OpenData is free to use under the\n' +
        '                  <a\n' +
        '                    href="http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"\n' +
        '                    target="_blank"\n' +
        '                    >Open Government Licence (OGL)</a',
      attribution_english: 'Ordnance Survey',
    },
    {
      country: 'United Kingdom (Northern Ireland)',
      attribution: '© Land and Property Services (LPS)',
      attribution_english: 'Land and Property Services',
    },
  ];

  public static EuroDEM = [
    {
      country: 'Austria',
      attribution_statement: '© Bundesamt für Eich- und Vermessungswesen (BEV)',
    },
    {
      country: 'Belgium',
      attribution_statement: '© Institut Géographique National (IGN-B)',
    },
    {
      country: 'Croatia',
      attribution_statement: '© Državna Geodetska Uprava (DGU)',
    },
    {
      country: 'Cyprus',
      attribution_statement: '© Tmima Ktimatologiou Kai Chorometrias (DLS)',
    },
    {
      country: 'Czech Republic',
      attribution_statement: '© Český úřad zeměměřický a katastrální (CZUK)',
    },
    {
      country: 'Denmark',
      attribution_statement:
        '© Energi-, forsynings- og klimaministeriet / Styrelsen for Dataforsyning og Effektivisering (SDFE)',
    },
    {
      country: 'Estonia',
      attribution_statement: '© Eesti Maa-amet (MAAAMET)',
    },
    {
      country: 'Finland',
      attribution_statement: '© Maanmittauslaitos (NLS-F)',
    },
    {
      country: 'France',
      attribution_statement:
        '© Institut national de l’information géographique et forestière (IGN-F)',
    },
    {
      country: 'Germany',
      attribution_statement: '© Bundesamt für Kartographie und Geodäsie',
    },
    {
      country: 'Greece',
      attribution_statement: '© ΓΕΩΓΡΑΦΙΚΗ ΥΠΗΡΕΣΙΑ ΣΤΡΑΤΟΥ (HMGS)',
    },
    {
      country: 'Hungary',
      attribution_statement: '© Lechner Tudásközpont Nonprofit Korlátolt Felelősségű Társaság',
    },
    {
      country: 'Iceland',
      attribution_statement: '© Landmælingar Íslands (LMI)',
    },
    {
      country: 'Ireland',
      attribution_statement: '© Ordnance Survey Ireland (OSI)',
    },
    {
      country: 'Italy',
      attribution_statement: '© Istituto Geografico Militare (IGM)',
    },
    {
      country: 'Latvia',
      attribution_statement: '© Latvijas Ģeotelpiskās informācijas aģentūra (LGIA)',
    },
    {
      country: 'Lithuania',
      attribution_statement: '© Nacionalinė žemės tarnyba prie Žemės ūkio ministerijos (NLS-L)',
    },
    {
      country: 'Luxembourg',
      attribution_statement: '© Administration du Cadastre et de la Topographie',
    },
    {
      country: 'Malta',
      attribution_statement: '© Malta Environment and Planning Authority (MEPA)',
    },
    {
      country: 'Moldova',
      attribution_statement: '© Agenţia Relaţii Funciare şi Cadastru a Republicii Moldova (ARFC)',
    },
    {
      country: 'Netherlands',
      attribution_statement: '© Kadaster (KADASTER)',
    },
    {
      country: 'Norway',
      attribution_statement: '© Kartverket (KARTVERKET)',
    },
    {
      country: 'Poland',
      attribution_statement: '© Główny Urząd Geodezji i Kartografii (GUGIK)',
    },
    {
      country: 'Portugal',
      attribution_statement: '© Direção Geral do Território (DGT)',
    },
    {
      country: 'Rep. of Slovakia',
      attribution_statement: '© Úrad geodézie, kartografie a katastra Slovenskej republiky (UGKK)',
    },
    {
      country: 'Slovenia',
      attribution_statement: '© Geodetska uprava Republike Slovenije (GU)',
    },
    {
      country: 'Spain',
      attribution_statement: '© Centro Nacional de Información Geográfica (CNIG)',
    },
    {
      country: 'Sweden',
      attribution_statement: '© Lantmäteriet (LANTMÄTERIET)',
    },
    {
      country: 'Switzerland',
      attribution_statement: '© Bundesamt für Landestopographie (swisstopo)',
    },
  ];

  public static OpenGazetteer = [
    {
      member: 'National Geographic Institute, Belgium',
      attribution: '© Institut Géographique National (IGNBelgium)',
    },
    {
      member: 'Geodesy, Cartography and Cadastre Agency (GCCA) of the Republic of Bulgaria',
      attribution: '© Cadastre Agency, MRDPW',
    },
    {
      member: 'State Geodetic Administration of the Republic of Croatia',
      attribution: '© Drzavna Geodetska Uprava (DGU)',
    },
    {
      member: 'Czech Office for Surveying, Mapping and Cadastre',
      attribution: '© Český úřad zeměměřický a katastrální (CUZK)',
    },
    {
      member: 'Cyprus Department of Lands and Surveys',
      attribution: '© Department of Lands and Surveys (DLS)',
    },
    {
      member: 'Agency for Data Supply and Efficiency, Denmark',
      attribution: '© SDFE + name of data + date downloaded',
    },
    {
      member: 'Estonian Land Board',
      attribution: '© Estonian Land Board',
    },
    {
      member: 'National Land Survey of Finland',
      attribution: '© National Land Survey of Finland',
    },
    {
      member: 'Italian Military Geographic Institute',
      attribution: '© Istituto Geografico Militare Italiano',
    },
    {
      member: 'National Institute of Geographic and Forest Information, France',
      attribution: '©IGN France - Reference year of the IGN data',
    },
    {
      member: 'Federal Agency for Cartography and Geodesy, Germany',
      attribution: '© GeoBasis-DE / BKG 2018',
    },
    {
      member: 'National Agency of Public Registry, Georgia',
      attribution: 'No attribution required',
    },
    {
      member: 'Ordnance Survey, Great Britain',
      attribution:
        ' &copy; Ordnance Survey data: &copy; Crown copyright and database right [year] OS\n' +
        '                  OpenData is free to use under the\n' +
        '                  <a\n' +
        '                    href="http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"\n' +
        '                    target="_blank"\n' +
        '                    >Open Government Licence (OGL)</a\n' +
        '                  >.',
    },
    {
      member: 'Hellenic Military Geographical Service, Greece',
      attribution: '© Data produced by HMGS for EuroGeographics',
    },
    {
      member: 'Geoinformation Service of Hungarian Defence Forces',
      attribution: 'No attribution required',
    },
    {
      member: 'National Land Survey of Iceland',
      attribution: '© National Land Survey of Iceland',
    },
    {
      member: 'Ordnance Survey Ireland',
      attribution: '© Contains Ordnance Survey Ireland Data licensed under ELS Open Data Licence',
    },
    {
      member: 'Kosovo Cadastral Agency',
      attribution: '© Kosova Cadastral Agency',
    },
    {
      member: 'Latvian Geospatial Information Agency',
      attribution: 'Latvijas Republikas Valsts zemes dienests',
    },
    {
      member: 'National Land Service under the Ministry of Agriculture, Lithuania',
      attribution:
        'EBM_100LT © National land service under the ministry of agriculture of the Republic of Lithuania, logo;' +
        '\n\nERM_250LT© National land service under the ministry of agriculture of the Republic of Lithuania, logo',
    },
    {
      member: 'Administration of the Cadastre and Topography, Luxembourg',
      attribution: 'CC0',
    },
    {
      member: 'North Macedonia',
      attribution: '© Агенција за катастар на недвижности (KATASTAR)',
    },
    {
      member: 'Malta Environment and Planning Authority',
      attribution: '© Malta Environment and Planning Authority (MEPA)',
    },
    {
      member: 'State Agency for Land Relations and Cadastre, Moldova',
      attribution: '© State Agency for Land Relations and Cadastre',
    },
    {
      member: 'Land and Property Services, Northern Ireland',
      attribution: 'No attribution required',
    },
    {
      member: 'Norwegian Mapping Authority',
      attribution: 'CC-BY 4.0',
    },
    {
      member: 'Kadaster Netherlands',
      attribution: '© Kadaster NL',
    },
    {
      member: 'Head Office of Geodesy and Cartography, Poland',
      attribution: '© Główny Urząd Geodezji i Kartografii (GUGIK)',
    },
    {
      member: 'Directorate General for Territory, Portugal',
      attribution: '© Direção Geral do Território',
    },
    {
      member: 'Surveying and Mapping Authority of the Republic of Slovenia',
      attribution: 'No attribution required',
    },
    {
      member: 'The Swedish mapping, cadastral and land registration authority',
      attribution: '© Lantmäteriet',
    },
    {
      member: 'National Geographic Institute, Spain',
      attribution: 'CC-BY 4.0 scne.es',
    },
    {
      member: 'Geodesy, Cartography and Cadastre Authority of the Slovak Republic',
      attribution: 'No attribution required',
    },
    {
      member: 'Federal Office of Topography Switzerland',
      attribution:
        'Quelle: Bundesamt fur Landestopografie swisstopo (art 30. GeoIV) Source: Office federal de topographie (art. 30 Ogeo) Fonte: Ufficio federale di topografia (art. 30 OGI) Source: Swiss Fereral Office of Topography (Article 30, Geoinformation Ordinance)',
    },
    {
      member: 'State Service of Geodesy, Cartography and Cadastre, Ukraine',
      attribution: '© Research Institute of Geodesy and Cartography',
    },
  ];

  public static OpenCadastralMap = [
    {
      country: 'Czech Republic',
      member: 'Czech Office for Surveying, Mapping and Cadastre',
      attribution_statement: '© Český úřad zeměměřický a katastrální (CUZK)',
    },
    {
      country: 'Denmark including Faroe Islands',
      member:
        'Danish Ministry of Energy, Utilities and Climate / Agency for Data supply and Efficiency',
      attribution_statement:
        '© Energi-, forsynings- og klimaministeriet / Styrelsen for Dataforsyning og Effektivisering (SDFE)',
    },
    {
      country: 'Netherlands',
      member: 'Cadastre, Land Registry and Mapping Agency, The Netherlands',
      attribution_statement: '© Kadaster (KADASTER)',
    },
    {
      country: 'Poland',
      member: 'Head Office of Geodesy and Cartography, Poland',
      attribution_statement: '© Head Office of Geodesy and Cartography (GUGIK)',
    },
    {
      country: 'Slovenia',
      member: 'Surveying and Mapping Authority of the Republic of Slovenia',
      attribution_statement: '© Geodetska uprava Republike Slovenije (GU)',
    },
    {
      country: 'Spain',
      member: 'General Directorate for the Cadastre, Spain',
      attribution_statement: '© Dirección General del Catastro (DGC)',
    },
    {
      country: 'Spain',
      member: 'National Geographic Institute Spain',
      attribution_statement: '© National Geographic Institute (NGI)',
    },
  ];

  public static HVLSP = [
    {
      country: 'Belgium',
      attribution: '© Institut Géographique National (IGN-B)',
      attribution_english: 'National Geographic Institute',
    },
    {
      country:
        'France including\n' +
        'French Guiana,\n' +
        'Guadeloupe,\n' +
        'Martinique,\n' +
        'Mayotte,\n' +
        'Monaco,\n' +
        'Réunion,\n' +
        'Saint Barthélemy and\n' +
        'Saint Martin',
      attribution: '© Institut national de l’information géographique et forestière (IGN-F)',
      attribution_english: 'National Institute of Geographic and Forest Information',
    },
    {
      country: 'Netherlands',
      attribution: '© Kadaster (KADASTER)',
      attribution_english: 'Cadastre, Land Registry and Mapping Agency',
    },
    ];
}
